import { CardShell, GameweekGrid, PlayerHeader, TitleBar } from './card-chrome';
import type { Player } from '@api-service/players';
import type { GameweekWindowEntry } from '@lib/article-blocks/types';

type PlayerFixturesCardProps = {
  player: Player;
  gameweeks: GameweekWindowEntry[];
};

export const PlayerFixturesCard = ({
  player,
  gameweeks
}: PlayerFixturesCardProps) => {
  const columns = Math.max(gameweeks.length, 1);
  return (
    <CardShell testId="player-fixtures-card">
      <PlayerHeader player={player} />
      <TitleBar
        title="Player fixtures"
        detail={`Next ${columns} GW${columns === 1 ? '' : 's'}`}
      />
      <GameweekGrid gameweeks={gameweeks} />
    </CardShell>
  );
};
